// import React, { useEffect, useState } from "react";
// import "./IndexPageLayout.css";

// import useAuthStore from "../../Zustand/Store/useAuthStore";
// import {
//   Link,
//   Navigate,
//   useLocation,
//   useNavigate,
//   useParams,
// } from "react-router-dom";
// import Footer from "../../Components/Footer/Footer";
// import PersonIcon from "@mui/icons-material/Person";
// import TuneIcon from "@mui/icons-material/Tune";

// import {
//   Box,
//   CssBaseline,
//   Drawer,
//   AppBar,
//   Toolbar,
//   Typography,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   IconButton,
//   useTheme,
//   createTheme,
//   ThemeProvider,
//   MenuItem,
//   Menu,
//   Tooltip,
//   Avatar,
//   Badge,
//   Popover,
// } from "@mui/material";

// import {
//   Mail as MailIcon,
//   Notifications as NotificationsIcon,
//   Brightness4 as Brightness4Icon,
//   Brightness7 as Brightness7Icon,
//   Menu as MenuIcon,
//   Logout as LogoutIcon,
//   Lock as LockIcon,
//   Edit as EditIcon,
//   Dashboard as DashboardIcon,
//   CorporateFare as CorporateFareIcon,
//   Business as BusinessIcon,
//   AddLocationAlt as AddLocationAltIcon,
//   Assignment as AssignmentIcon,
//   Settings as SettingsIcon,
//   Engineering as EngineeringIcon,
//   Store as StoreIcon,
//   Segment as SegmentIcon,
//   AppRegistration as AppRegistrationIcon,
//   Apartment as ApartmentIcon,
//   FormatAlignJustify as FormatAlignJustifyIcon,
//   Autorenew as AutorenewIcon,
//   ExitToApp as ExitToAppIcon,
//   VerifiedUser as VerifiedUserIcon,
//   LocalPolice as LocalPoliceIcon,
//   AccountCircleOutlined,
//   PeopleAltOutlined,
// } from "@mui/icons-material";

// import Swal from "sweetalert2";
// import axios from "axios";
// import { MAIN_URL } from "../../Configurations/Urls";
// import ExpandedSideOption from "./ExpandedSideOption";
// import ExpandTopBarDropOption from "./ExpandTopBarDropOption";
// import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
// import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
// import ErrorIcon from "@mui/icons-material/Error";
// import GroupIcon from "@mui/icons-material/Group";

// export default function RouteProtector({ children }) {

//   const [sidebarVisible, setSidebarVisible] = useState(true);
//       let [showSidebar , SetshowSidebar] = useState(true);

//   const [anchorElTune, setAnchorElTune] = useState(null);

//   const handleOpenTuneMenu = (event) => {
//     setAnchorElTune(event.currentTarget);
//   };

//   const handleCloseTuneMenu = () => {
//     setAnchorElTune(null);
//   };

//   const handleSelectOption = (option) => {
//     console.log("Selected:", option);
//     // Example: navigate based on selected option
//     if (option === "PROJECTIFY") navigate("/");
//     else if (option === "Project Management") navigate("/");

//     handleCloseTuneMenu();
//   };

//   const [darkMode, setDarkMode] = useState(false);
//   const [collapsed, setCollapsed] = useState(false);
//   const [drawerWidth, setDrawerWidth] = useState(290);
//   const [isResizing, setIsResizing] = useState(false);

//   const theme = React.useMemo(
//     () =>
//       createTheme({
//         palette: {
//           mode: darkMode ? "dark" : "light",
//         },
//         components: {
//           MuiOutlinedInput: {
//             styleOverrides: {
//               input: {
//                 backgroundColor: darkMode ? "#1e1e1e" : "#ffffff", // ✅ dynamic bg color
//                 "&:-webkit-autofill": {
//                   WebkitBoxShadow: `0 0 0 1000px ${darkMode ? "#1e1e1e" : "#ffffff"} inset`,
//                   WebkitTextFillColor: darkMode ? "#fff" : "#000",
//                 },
//                 "&:focus": {
//                   backgroundColor: darkMode ? "#1e1e1e" : "#ffffff",
//                 },
//               },
//             },
//           },
//         },
//       }),
//     [darkMode]
//   );

//   const navigate = useNavigate();
//   const location = useLocation();

//   const [anchorElUser, setAnchorElUser] = useState(null);

//   const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
//   const handleCloseUserMenu = () => setAnchorElUser(null);

//   useEffect(() => {
//     const handleMouseMove = (e) => {
//       if (isResizing) {
//         const newWidth = Math.min(Math.max(e.clientX, 75), 400);
//         setDrawerWidth(newWidth);
//       }
//     };

//     const handleMouseUp = () => {
//       if (isResizing) setIsResizing(false);
//     };

//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);

//     return () => {
//       document.removeEventListener("mousemove", handleMouseMove);
//       document.removeEventListener("mouseup", handleMouseUp);
//     };
//   }, [isResizing]);

//   const { logout, userData, setAccess, login } = useAuthStore();
//   const access = userData?.role || "Admin";

//   const handleLogout = () => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You want to logout?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, logout",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           const token = localStorage.getItem("token");

//           await axios.get(`${MAIN_URL}/api/auth/logout`, {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           });

//           logout();
//           localStorage.removeItem("token");

//           Swal.fire("Logged out!", "You have been logged out.", "success");
//           navigate("/login");
//         } catch (error) {
//           console.error("Logout failed:", error);
//           Swal.fire("Error", "Logout failed. Please try again.", "error");
//         }
//       }
//     });
//   };

//   const { isLoggedIn } = useAuthStore();
//   let [OpenTCode, setOpenTCode] = useState(false);

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.ctrlKey && e.key === "/") {
//         setOpenTCode(true);
//       }
//     };
//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, []);

//   useEffect(() => {
//     const currentPath = location.pathname;
//     localStorage.setItem("lastVisitedRoute", currentPath);
//   }, [location]);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const lastVisitedRoute = localStorage.getItem("lastVisitedRoute");

//     if (!token) {
//       navigate("/login");
//       return;
//     }

//     axios
//       .get(`${MAIN_URL}/api/auth/token-login`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         const { user } = response.data;

//         setAccess(user?.role?.system_role_name);
//         login(user);

//         let dd = user.organization.find(
//           (item) =>
//             item.organization_id ==
//             user.user_active_organization.organization_id
//         );

//         let mm = {
//           ...user,
//           organization: dd,
//         };
//         login(mm);

//         navigate(lastVisitedRoute);
//       })

//       .catch((error) => {
//         navigate("/login");
//       });
//   }, []);

//   let sidebarOptions = [
//     { kind: "header", title: "Features" },
//     {
//       heading: "Dashboard",
//       route: "/",
//       title: "Dashboard",
//       icon: <DashboardIcon />,
//     },
//     { kind: "divider" },
//     {
//       heading: "Organization",
//       title: "Organization",
//       icon: <SettingsIcon />,
//       route: "/organization/switcher",
//     },
//     {
//       heading: "Trainings",
//       title: "Trainings",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/training-programs",
//           title: "Training Programs",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/training-programs-categories",
//           title: "Training Program Categories",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },
//     {
//       heading: "Students",
//       title: "Students",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/students",
//           title: "Students",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/students-fees",
//           title: "Student Fees",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },
//     {
//       heading: "Leads",
//       title: "Leads",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/leads",
//           title: "Leads",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/lead-stages",
//           title: "Lead Stages",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/lead-sources",
//           title: "Lead Sources",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/lead-activities",
//           title: "Lead Activities",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/lead-contact-timings",
//           title: "Lead Contact Timings",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },
//     {
//       heading: "Assesments",
//       title: "Assesments",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/assesments",
//           title: "Assesments",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/assesment-results",
//           title: "Assessment Results",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },
//     {
//       heading: "Batches",
//       title: "Batches",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/batches",
//           title: "Batches",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/batch-classes",
//           title: "Batch Classes",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/batch-students",
//           title: "Batch Students",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },
//     {
//       heading: "Others",
//       title: "Others",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/recruitment-agencies",
//           title: "Recruitment Agencies",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/companies",
//           title: "Companies",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/admissions",
//           title: "Admissions",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/fee-installments",
//           title: "Fee Installments",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/classes-attendance",
//           title: "Classes Attendance",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/certificates",
//           title: "Certificates",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/placement-referrals",
//           title: "Placement Referrals",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/demo-sessions",
//           title: "Demo Sessions",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },

//     {
//       heading: "Logout",
//       route: "/logout",
//       title: "Logout",
//       icon: <LogoutIcon />,
//     },
//   ];

//   const currentPath = location.pathname;

//   // 🔐 Route-based Access Control

//   // Protect Employees Page from Admins
//   if (access === "Admin" && currentPath === "/sidebar-option-page-1") {
//     return <Navigate to="/" replace />;
//   }

//   // Protect Admin-only page from Users
//   if (access === "User" && currentPath === "/Admin-only-route") {
//     return <Navigate to="/" replace />;
//   }

//   console.log("axcess", access);
//   console.log("userdata", userData);

//   return (
//     <ThemeProvider theme={theme}>
//       <Box sx={{ display: "flex", height: "100vh" }}>
//         <CssBaseline />
//         <AppBar position="fixed" sx={{ zIndex: 1201 }}>
//           <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
//             <Box sx={{ display: "flex", alignItems: "center" }}>
//               {showSidebar && (
//                 <IconButton
//                   color="inherit"
//                   onClick={() => setSidebarVisible(!sidebarVisible)}
//                   edge="start"
//                 >
//                   <MenuIcon />
//                 </IconButton>
//               )}
//               <Typography variant="h6" noWrap sx={{ ml: 1 }}>
//                 EMS
//               </Typography>
//             </Box>

//             <Box sx={{ flexGrow: 1, marginLeft: "220px", textAlign: "left" }}>
//       <Typography
//         variant="h6"
//         sx={{
//           textTransform: "capitalize",
//           cursor: "pointer",
          
//         }}
//         noWrap
//         onClick={() => navigate("/organization/switcher")}
//       >
//         {userData?.organization?.organization_name}
//       </Typography>
//     </Box>
//             <Box
//               sx={{
//                 flexGrow: 0,
//                 gap: 1,
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               <Typography
//                 variant="h6"
//                 sx={{ textTransform: "capitalize", ml: 1 }}
//                 noWrap
//               >
//                 {userData?.full_name}
//               </Typography>
//               <IconButton
//                 color="inherit"
//                 onClick={() => setDarkMode(!darkMode)}
//               >
//                 {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
//               </IconButton>
//               <Tooltip title="Open settings">
//                 <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
//                   <Avatar>
//                     <PersonIcon />
//                   </Avatar>
//                 </IconButton>
//               </Tooltip>

//               <Popover
//                 anchorEl={anchorElUser}
//                 open={Boolean(anchorElUser)}
//                 onClose={handleCloseUserMenu}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//                 transformOrigin={{ vertical: "top", horizontal: "right" }}
//                 PaperProps={{ sx: { mt: 1, p: 1, width: 290 } }}
//               >
//                 <List disablePadding>
//                   {access.system_role_name === "Admin" && (
//                     <MenuItem
//                       onClick={() => {
//                         navigate("/my-profile");
//                       }}
//                     >
//                       Profile
//                     </MenuItem>
//                   )}
//                   <ExpandTopBarDropOption
//                     handleCloseUserMenu={handleCloseUserMenu}
//                     name={"Settings"}
//                     list={[
//                       {
//                         name: "Change Password",
//                         url: "/settings/change-password",
//                       },
//                       access === "Admin" && {
//                         name: "Update Credentials",
//                         url: "/settings/update-credentials",
//                       },
//                     ]}
//                   />
//                   <MenuItem
//                     onClick={() => {
//                       handleLogout();
//                     }}
//                   >
//                     Logout
//                   </MenuItem>
//                 </List>
//               </Popover>
//             </Box>

//             {/* <IconButton color="inherit" onClick={handleOpenTuneMenu}>
//               <TuneIcon />
//             </IconButton>
//             <Menu
//               anchorEl={anchorElTune}
//               open={Boolean(anchorElTune)}
//               onClose={handleCloseTuneMenu}
//               anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//               transformOrigin={{ vertical: "top", horizontal: "right" }}
//               PaperProps={{ sx: { mt: 1, width: 220 } }}
//             >
//               <MenuItem onClick={() => handleSelectOption("PROJECTIFY")}>
//                 PROJECTIFY
//               </MenuItem>
//               <MenuItem
//                 onClick={() => handleSelectOption("Project Management")}
//               >
//                 Project Management
//               </MenuItem>
//             </Menu> */}
//           </Toolbar>
//         </AppBar>

//         {showSidebar && sidebarVisible && (
//           <Drawer
//             variant="permanent"
//             sx={{
//               height: "100vh",
//               width: collapsed ? 75 : drawerWidth,
//               flexShrink: 0,
//               whiteSpace: "nowrap",
//               transition: "width 0.3s",
//               [`& .MuiDrawer-paper`]: {
//                 width: collapsed ? 75 : drawerWidth,
//                 transition: "width 0.3s",
//                 overflowX: "hidden",
//                 overflowY: "auto",
//                 boxSizing: "border-box",
//                 position: "relative",
//                 height: "100vh",
//               },
//             }}
//           >
//             <Toolbar />
//             <Box sx={{ pt: 2 }}>
//               <List>
//                 {sidebarOptions?.map((item, index) => {
//                   if (item.kind === "divider")
//                     return <Divider key={index} sx={{ my: 1 }} />;
//                   if (item.kind === "header")
//                     return (
//                       !collapsed && (
//                         <Typography
//                           key={index}
//                           variant="subtitle2"
//                           sx={{
//                             pl: 2,
//                             pt: 1.5,
//                             pb: 0.5,
//                             color: "text.secondary",
//                           }}
//                         >
//                           {item.title}
//                         </Typography>
//                       )
//                     );
//                   if (item.children) {
//                     return (
//                       <ExpandedSideOption
//                         collapsed={collapsed}
//                         item={item}
//                         key={index}
//                       />
//                     );
//                   }
//                   return (
//                     <ListItem
//                       button
//                       key={item.heading}
//                       onClick={() =>
//                         item.title === "Logout"
//                           ? handleLogout()
//                           : navigate(item.route)
//                       }
//                       sx={{ py: 1, minWidth: "40px", cursor: "pointer" }}
//                     >
//                       {item.icon && (
//                         <ListItemIcon
//                           sx={{ minWidth: "35px", cursor: "pointer" }}
//                         >
//                           {item.icon}
//                         </ListItemIcon>
//                       )}
//                       {!collapsed && (
//                         <ListItemText
//                           primary={item.title}
//                           sx={{ cursor: "pointer" }}
//                         />
//                       )}
//                     </ListItem>
//                   );
//                 })}
//               </List>
//             </Box>

//             {!collapsed && (
//               <Box
//                 onMouseDown={() => setIsResizing(true)}
//                 sx={{
//                   position: "absolute",
//                   top: 0,
//                   right: 0,
//                   width: "5px",
//                   height: "100%",
//                   cursor: "col-resize",
//                   zIndex: 999,
//                 }}
//               />
//             )}
//           </Drawer>
//         )}
//         <Box
//           component="main"
//           sx={{
//             flexGrow: 1,
//             bgcolor: "background.default",
//             transition: "margin-left 0.3s",
//             overflowY: "auto", // Enable vertical scroll for right side
//             height: "100vh",
//           }}
//         >
//           <Toolbar />
//           {children}
//           {/* <Footer /> */}
//         </Box>
//       </Box>
//     </ThemeProvider>
//   );
// }




"use client";
import React, { useEffect, useMemo, useState } from "react";
import "./IndexPageLayout.css";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import usePermissionDataStore from "../../Zustand/Store/usePermissionDataStore";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  CssBaseline,
  ThemeProvider,
  useMediaQuery,
} from "@mui/material";
import { createEmsTheme } from "../../theme/emsMuiTheme";

import {
  Menu as MenuIcon,
  Lock as LockIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import { ChevronsUpDown, Bell, CalendarClock, CheckCircle2, CircleHelp, ClipboardPen, Settings as SettingsLucide, Search, Moon, Sun, Trash2, CreditCard, ArrowUpRight, Wallet } from "lucide-react";

import Swal from "sweetalert2";
import axios from "axios";
import { MAIN_URL, getApiHeaders } from "../../Configurations/Urls";
import useEmployeeDataStore from "../../Zustand/Store/useEmployeeDataStore";
import { routes } from "../../Configurations/PermissionConfigrations";
import NotAllowed from "../../Exceptions/NotAllowed";
import {
  normalizeUserOrganizationSession,
  resolveOrganizationFromUserData,
  resolveOrganizationId,
  resolveOrganizationUserId,
} from "../../Utils/organizationSession";
import SideBar from "../../Assets/Static/SideBar";
import {
  applyPreferredOrganizationToUserPayload,
  clearClientPreferredOrganizationId,
  setClientPreferredOrganizationId,
} from "../../Utils/clientActiveOrganization";
import {
  canViewOrganizationPage,
  hasPermissionAction,
} from "../../Utils/organizationPermissions";
import { getDefaultHomePath } from "../../Utils/defaultHomePath";
import { resolveUserRoleLabel } from "../../Utils/resolveUserRoleLabel";
import {
  isTrainerPortalUser,
  TRAINER_PORTAL_ROUTES,
  withTrainerPortalPermissions,
} from "../../Utils/trainerPortal";
import InssureLogo from "../../Components/InssureLogo";
import InstituteSettingsDialog from "../../Components/Settings/InstituteSettingsDialog";
import NotificationPreferencesDialog from "../../Components/Settings/NotificationPreferencesDialog";
import ListPersonAvatar, {
  resolveUserProfileImageUrl,
} from "../../Components/Table/ListPersonAvatar";
import { isStudentUser } from "../../Utils/isStudentUser";
import {
  allowedWorkspaces,
  resolveActiveWorkspace,
  setStoredWorkspace,
  trainerListPath,
  workspaceForPath,
  workspaceHomePath,
  WORKSPACE_LABELS,
  WORKSPACES,
} from "../../Utils/workspaces";
import {
  getLoginPathAfterLogout,
  rememberStudentPortalSlug,
} from "../../Utils/studentPortalPath";
import useNotificationStore from "../../Zustand/Store/useNotificationStore";
import {
  connectNotificationSocket,
  disconnectNotificationSocket,
  resubscribeNotificationSocket,
} from "../../Utils/notificationSocket";
import { format as timeAgoFormat } from "timeago.js";
import {
  STUDENT_NOTIF_READ_EVENT,
  filterUnreadStudentNotifications,
  markStudentNotificationRead,
  studentNotificationId,
} from "../../Utils/studentNotifications";

const ADMIN_NOTIF_TABS = [
  { key: "all", label: "All" },
  { key: "engagement", label: "Engagement" },
  { key: "operations", label: "Operations" },
  { key: "outcomes", label: "Outcomes" },
];

function studentNotificationIcon(type) {
  if (type === "assessment") return <ClipboardPen size={16} />;
  if (type === "result") return <CheckCircle2 size={16} />;
  if (type === "fee") return <Wallet size={16} />;
  if (type === "class") return <CalendarClock size={16} />;
  return <Bell size={16} />;
}

// Overlay onto edition-filtered allowed_actions from the shared Admin template.
// Do not add placement (or other edition-gated) codes here — they bypass edition filtering.
const MENU_PERMISSION_CODES = [
  "VIEW_LEAD_ACTIVITY_REPORT",
  "VIEW_COUNSELLOR_REPORT",
];

function applicationRoleIdFromUser(userData) {
  return (
    userData?.application_user_role_id ||
    userData?.organizationuser?.role_assignment?.application_user_role?.application_user_role_id ||
    userData?.organizationuser?.RoleAssignment?.ApplicationUserRole?.application_user_role_id ||
    userData?.role?.application_user_role_id ||
    null
  );
}

async function mergeGrantedMenuPermissions(allowed, userData) {
  const list = Array.isArray(allowed) ? [...allowed] : [];
  const roleId = applicationRoleIdFromUser(userData);
  if (!roleId) return list;

  try {
    const res = await axios.get(
      `${MAIN_URL}/api/application/role-permissions/particular/${roleId}`,
      { headers: getApiHeaders() }
    );
    const seen = new Set(list.map((item) => String(item).trim().toUpperCase()));
    (res?.data?.permissions || []).forEach((row) => {
      const code = String(row?.module_action_code || "").trim().toUpperCase();
      if (!row?.permission_allowed || !MENU_PERMISSION_CODES.includes(code) || seen.has(code)) {
        return;
      }
      seen.add(code);
      list.push(code);
    });
  } catch {
    return list;
  }

  return list;
}

let lastCompletedPermissionOrgUserId = null;

function permissionsAlreadyLoaded(orgUserId) {
  if (orgUserId == null || orgUserId === "") return false;
  const id = Number(orgUserId);
  if (!Number.isFinite(id)) return false;
  const existing = usePermissionDataStore.getState().Permission;
  return (
    lastCompletedPermissionOrgUserId === id &&
    Array.isArray(existing) &&
    existing.length > 0
  );
}

export default function RouteProtector({ children }) {
  const [darkMode, setDarkMode] = useState(() => {
    try {
      return localStorage.getItem("ems_dark_mode") === "true";
    } catch {
      return false;
    }
  });
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem("ems-collapsed") === "1";
    } catch {
      return false;
    }
  });
  const [drawerWidth, setDrawerWidth] = useState(310);
  const [isResizing, setIsResizing] = useState(false);
  const { resetData } = useEmployeeDataStore();
  const { Permission, isPermissionLoaded, setPermission } =
    usePermissionDataStore();

  const isMobile = useMediaQuery("(max-width:768px)", { noSsr: true });
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem("ems_dark_mode", String(darkMode));
    } catch {
      // Ignore storage failures (private mode / blocked storage).
    }
    document.documentElement.setAttribute("data-theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  const theme = React.useMemo(
    () => createEmsTheme(darkMode ? "dark" : "light"),
    [darkMode]
  );

  const navigate = useNavigate();
  const location = useLocation();

  const [activeMenu, setActiveMenu] = useState(null); // 'user' | 'notif' | 'org' | null
  const [orgQuery, setOrgQuery] = useState("");
  const [allClientOrgs, setAllClientOrgs] = useState([]);
  const [orgListLoading, setOrgListLoading] = useState(false);
  const [orgSwitching, setOrgSwitching] = useState(null); // org_id being switched to
  const [instituteSettingsOpen, setInstituteSettingsOpen] = useState(false);
  const [notificationPrefsOpen, setNotificationPrefsOpen] = useState(false);
  const [studentNotifications, setStudentNotifications] = useState([]);
  const [studentNotifsLoading, setStudentNotifsLoading] = useState(false);

  const toggleMenu = (m) => {
    setActiveMenu((cur) => {
      const next = cur === m ? null : m;
      if (next === "org") {
        setOrgQuery("");
      }
      return next;
    });
  };
  const closeMenu = () => setActiveMenu(null);

  const switchOrg = async (orgId) => {
    if (orgSwitching) return;
    setOrgSwitching(orgId);
    try {
      const response = await axios.post(
        `${MAIN_URL}/api/organizations/extra/active`,
        { organization_id: orgId, application_user_id: userData?.application_user_id },
        { headers: getApiHeaders({ Authorization: `Bearer ${localStorage.getItem("token")}` }) }
      );
      const { user } = response.data;
      const allOrgs = Array.isArray(user?.organization) ? user.organization : allClientOrgs;
      const activeOrg = allOrgs.find((o) => Number(o.organization_id) === Number(orgId)) || allClientOrgs.find((o) => Number(o.organization_id) === Number(orgId)) || null;
      setClientPreferredOrganizationId(orgId);
      const nextUser = { ...user, organizations: allOrgs, organization: activeOrg };
      login(nextUser);
      setAccess(resolveUserRoleLabel(nextUser));
      closeMenu();
      navigate(getDefaultHomePath(nextUser));
    } catch (e) {
      console.error("Org switch failed", e);
    } finally {
      setOrgSwitching(null);
    }
  };

  useEffect(() => {
    if (!activeMenu) return;
    const isInsideOpenMenu = (target) => {
      if (!(target instanceof Element)) return false;
      if (target.closest(".ems-tb-pop")) return true;
      if (activeMenu === "user" && target.closest(".ems-user-chip")) return true;
      if (activeMenu === "notif" && target.closest(".ems-notif-btn")) return true;
      if (activeMenu === "org" && target.closest(".ems-company-chip")) return true;
      return false;
    };
    const onDown = (e) => {
      if (!isInsideOpenMenu(e.target)) setActiveMenu(null);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setActiveMenu(null);
    };
    document.addEventListener("pointerdown", onDown, true);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onDown, true);
      document.removeEventListener("keydown", onKey);
    };
  }, [activeMenu]);

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setCollapsed((c) => {
        const next = !c;
        try {
          localStorage.setItem("ems-collapsed", next ? "1" : "0");
        } catch {
          // Ignore storage failures.
        }
        return next;
      });
    }
  };

  useEffect(() => {
    if (isMobile) {
      setMobileOpen(false);
    }
  }, [location.pathname, isMobile]);

  // Mobile home: Organizations card list (not Dashboard)
  useEffect(() => {
    if (!isMobile) return;
    if (location.pathname === "/" || location.pathname === "") {
      navigate("/organization/details", { replace: true });
    }
  }, [isMobile, location.pathname, navigate]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isResizing && !isMobile) {
        const newWidth = Math.min(Math.max(e.clientX, 100), 500);
        setDrawerWidth(newWidth);
      }
    };

    const handleMouseUp = () => {
      if (isResizing) setIsResizing(false);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isResizing, isMobile]);

  const { logout, userData, setAccess, login } = useAuthStore();
  const [workspaceTick, setWorkspaceTick] = useState(0);
  const activeWorkspace = useMemo(
    () => resolveActiveWorkspace(userData, Permission),
    [userData, Permission, workspaceTick]
  );
  const userWorkspaces = useMemo(
    () => allowedWorkspaces(userData, Permission),
    [userData, Permission]
  );
  const isStudentPortal = activeWorkspace === WORKSPACES.STUDENT;

  const switchWorkspace = (nextWorkspace) => {
    if (!nextWorkspace || nextWorkspace === activeWorkspace) return;
    if (!userWorkspaces.includes(nextWorkspace)) return;
    setStoredWorkspace(nextWorkspace);
    setWorkspaceTick((value) => value + 1);
    closeMenu();
    navigate(workspaceHomePath(nextWorkspace), { replace: true });
  };

  const allottedOrganizations = React.useMemo(() => {
    const fromOrg = Array.isArray(userData?.organization)
      ? userData.organization
      : userData?.organization
        ? [userData.organization]
        : [];
    const fromOrgs = Array.isArray(userData?.organizations) ? userData.organizations : [];
    const seen = new Set();
    return [...fromOrg, ...fromOrgs].filter((org) => {
      const id = org?.organization_id;
      if (id == null) return false;
      const key = String(id);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }, [userData]);

  React.useEffect(() => {
    setAllClientOrgs(allottedOrganizations);
    setOrgListLoading(false);
  }, [allottedOrganizations]);

  useEffect(() => {
    if (!isStudentPortal) return;
    const org = Array.isArray(userData?.organization)
      ? userData.organization[0]
      : userData?.organization;
    rememberStudentPortalSlug(
      org?.organization_short_name ||
        userData?.organizations?.[0]?.organization_short_name
    );
  }, [isStudentPortal, userData]);
  const {
    items: notificationItems,
    unreadCount,
    loading: notificationsLoading,
    activeCategory: notifCategory,
    loadUnreadCount,
    loadNotifications,
    markOneRead,
    markAllRead,
    removeOne,
    prependNotification,
    setUnreadCount,
    setActiveCategory,
  } = useNotificationStore();

  const isAdminRole = String(resolveUserRoleLabel(userData) || "").toLowerCase() === "admin";
  const notifTabs = isAdminRole ? ADMIN_NOTIF_TABS : [{ key: "all", label: "All" }];

  useEffect(() => {
    const current = useAuthStore.getState().userData;
    if (!current) return;
    const org = current.organization;
    const alreadyNormalized =
      org && !Array.isArray(org) && org.organization_id != null;
    if (alreadyNormalized) return;
    login(normalizeUserOrganizationSession(current));
  }, [login]);

  const activeOrganization = useMemo(
    () => resolveOrganizationFromUserData(userData),
    [userData]
  );

  const clearSessionAndGoToLogin = React.useCallback(() => {
    const loginPath = getLoginPathAfterLogout(useAuthStore.getState().userData);
    logout();
    localStorage.removeItem("token");
    clearClientPreferredOrganizationId();
    lastCompletedPermissionOrgUserId = null;
    navigate(loginPath, { replace: true });
  }, [logout, navigate]);

  const roleLabel = resolveUserRoleLabel(userData);

  const access = roleLabel || "User";
  const [loadPermission, setLoadPermission] = useState(
    () => !permissionsAlreadyLoaded(resolveOrganizationUserId(useAuthStore.getState().userData))
  );
  const activeOrganizationId = resolveOrganizationId(userData);
  const activeOrganizationUserId = resolveOrganizationUserId(userData);
  const studentPortalStudentId = (() => {
    const loginuser = Array.isArray(userData?.loginuser)
      ? userData.loginuser[0]
      : userData?.loginuser;
    return (
      loginuser?.organization_ems_student_id ||
      userData?.organization_ems_student_id ||
      ""
    );
  })();

  useEffect(() => {
    if (isStudentPortal) return;
    if (!activeOrganizationId || !localStorage.getItem("token")) return;
    loadUnreadCount(activeOrganizationId);
  }, [activeOrganizationId, loadUnreadCount, isStudentPortal]);

  // Student header avatar: load profile_image_url from organization_ems_students via portal/me.
  // If present → photo; if missing → ListPersonAvatar fallback icon.
  useEffect(() => {
    if (!isStudentUser(userData)) return;
    if (!activeOrganizationId || !localStorage.getItem("token")) return;

    let cancelled = false;

    (async () => {
      try {
        const res = await axios.get(`${MAIN_URL}/api/ems/portal/me`, {
          headers: getApiHeaders(),
          params: { organization_id: activeOrganizationId },
        });
        if (cancelled) return;

        const student = res?.data?.data;
        if (!student || typeof student !== "object") return;

        const photoUrl =
          student.profile_image_url != null &&
          String(student.profile_image_url).trim() !== ""
            ? student.profile_image_url
            : null;

        const countryName =
          student.country?.country_name ||
          student.country?.name ||
          student.country_name ||
          null;
        const studentCode =
          student.student_id != null && String(student.student_id).trim() !== ""
            ? String(student.student_id).trim()
            : null;

        const current = useAuthStore.getState().userData;
        if (!current || cancelled) return;

        const prevLogin = Array.isArray(current.loginuser)
          ? current.loginuser[0]
          : current.loginuser;
        const prevPhoto = prevLogin?.profile_image_url ?? current.profile_image_url ?? null;
        const samePhoto =
          String(prevPhoto || "") === String(photoUrl || "") &&
          Number(prevLogin?.organization_ems_student_id || 0) ===
            Number(student.organization_ems_student_id || 0) &&
          String(prevLogin?.student_id || "") === String(studentCode || "") &&
          String(prevLogin?.country_name || "") === String(countryName || "");
        if (samePhoto && prevLogin?.organization_ems_student_id) return;

        const nextLogin = {
          ...(prevLogin && typeof prevLogin === "object" ? prevLogin : {}),
          organization_ems_student_id: student.organization_ems_student_id,
          student_id: studentCode ?? prevLogin?.student_id,
          country_name: countryName ?? prevLogin?.country_name,
          first_name: student.first_name ?? prevLogin?.first_name,
          last_name: student.last_name ?? prevLogin?.last_name,
          email: student.email ?? prevLogin?.email,
          profile_image_url: photoUrl,
          ...(student.profile_image_file
            ? { profile_image_file: student.profile_image_file }
            : {}),
        };

        login({
          ...current,
          profile_image_url: photoUrl,
          loginuser: Array.isArray(current.loginuser) ? [nextLogin] : nextLogin,
        });
      } catch {
        // Keep session as-is; avatar falls back to icon when no usable URL.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    activeOrganizationId,
    login,
    userData?.application_user_id,
    userData?.organizationuser?.organization_user_id,
  ]);

  useEffect(() => {
    if (isStudentPortal) return;
    if (activeMenu === "notif" && activeOrganizationId) {
      const category = isAdminRole ? (notifCategory || "all") : "all";
      loadNotifications(activeOrganizationId, category);
    }
  }, [activeMenu, activeOrganizationId, notifCategory, loadNotifications, isAdminRole, isStudentPortal]);

  useEffect(() => {
    if (!isStudentPortal) return;
    if (!activeOrganizationId || !localStorage.getItem("token")) return;

    let cancelled = false;
    const loadStudentNotifications = async () => {
      setStudentNotifsLoading(true);
      try {
        const res = await axios.get(`${MAIN_URL}/api/ems/portal/dashboard`, {
          headers: getApiHeaders(),
          params: { organization_id: activeOrganizationId },
        });
        if (cancelled) return;
        const rows = Array.isArray(res?.data?.data?.notifications)
          ? res.data.data.notifications
          : [];
        setStudentNotifications(
          filterUnreadStudentNotifications(
            rows,
            activeOrganizationId,
            studentPortalStudentId
          )
        );
      } catch {
        if (!cancelled) setStudentNotifications([]);
      } finally {
        if (!cancelled) setStudentNotifsLoading(false);
      }
    };

    loadStudentNotifications();
    return () => {
      cancelled = true;
    };
  }, [isStudentPortal, activeOrganizationId, activeMenu, studentPortalStudentId]);

  useEffect(() => {
    if (!isStudentPortal) return undefined;
    const onRead = () => {
      setStudentNotifications((prev) =>
        filterUnreadStudentNotifications(
          prev,
          activeOrganizationId,
          studentPortalStudentId
        )
      );
    };
    window.addEventListener(STUDENT_NOTIF_READ_EVENT, onRead);
    return () => window.removeEventListener(STUDENT_NOTIF_READ_EVENT, onRead);
  }, [isStudentPortal, activeOrganizationId, studentPortalStudentId]);

  useEffect(() => {
    if (isStudentPortal) {
      disconnectNotificationSocket();
      return undefined;
    }
    const token = localStorage.getItem("token");
    if (!token || !activeOrganizationId) {
      disconnectNotificationSocket();
      return undefined;
    }

    connectNotificationSocket({
      token,
      organizationId: activeOrganizationId,
      onNotification: (payload) => {
        const notification = payload?.notification;
        if (notification) {
          prependNotification(notification);
        }
        if (typeof payload?.unread_count === "number") {
          setUnreadCount(payload.unread_count);
        } else {
          loadUnreadCount(activeOrganizationId);
        }
      },
    });

    return () => {
      disconnectNotificationSocket();
    };
  }, [
    activeOrganizationId,
    prependNotification,
    setUnreadCount,
    loadUnreadCount,
    isStudentPortal,
  ]);

  useEffect(() => {
    if (isStudentPortal) return;
    if (activeOrganizationId) {
      resubscribeNotificationSocket(activeOrganizationId);
    }
  }, [activeOrganizationId, isStudentPortal]);

  const handleNotifTab = (key) => {
    setActiveCategory(key);
    if (activeOrganizationId) {
      loadNotifications(activeOrganizationId, key);
    }
  };

  const handleNotificationClick = async (notification) => {
    if (!notification?.is_read) {
      await markOneRead(notification.notification_id);
    }
    closeMenu();
    if (notification?.link) {
      navigate(notification.link);
    }
  };

  const handleStudentNotificationClick = (notification) => {
    markStudentNotificationRead(
      activeOrganizationId,
      studentPortalStudentId,
      notification
    );
    const readId = studentNotificationId(notification);
    setStudentNotifications((prev) =>
      prev.filter((n) => studentNotificationId(n) !== readId)
    );
    closeMenu();
    if (notification?.href) {
      navigate(notification.href);
    }
  };

  const normalizedOrgUserId = useMemo(() => {
    if (
      activeOrganizationUserId == null ||
      activeOrganizationUserId === ""
    ) {
      return null;
    }
    const n = Number(activeOrganizationUserId);
    return Number.isFinite(n) ? n : null;
  }, [activeOrganizationUserId]);

  console.log("permission is ", Permission);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const token = localStorage.getItem("token");

          await axios.get(`${MAIN_URL}/api/auth/logout`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          const loginPath = getLoginPathAfterLogout(useAuthStore.getState().userData);
          logout();
          clearClientPreferredOrganizationId();
          lastCompletedPermissionOrgUserId = null;
          localStorage.removeItem("token");

          Swal.fire("Logged out!", "You have been logged out.", "success");
          navigate(loginPath);
        } catch (error) {
          console.error("Logout failed:", error);
          Swal.fire("Error", "Logout failed. Please try again.", "error");
        }
      }
    });
  };

  const { isLoggedIn } = useAuthStore();
  const [OpenTCode, setOpenTCode] = useState(false);
  const [trialBanner, setTrialBanner] = useState(null);

  const formatEndsOnLong = (dateStr) => {
    if (!dateStr) return "";
    const dt = new Date(`${dateStr}T00:00:00`);
    if (Number.isNaN(dt.getTime())) return String(dateStr);

    const parts = dt.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    // "29 August 2026" -> "29 August, 2026"
    const lastSpace = parts.lastIndexOf(" ");
    if (lastSpace === -1) return parts;
    const dayMonth = parts.slice(0, lastSpace);
    const year = parts.slice(lastSpace + 1);
    return `${dayMonth}, ${year}`;
  };

  useEffect(() => {
    const billingOnly =
      localStorage.getItem("ems_billing_only") === "1" ||
      Boolean(userData?.billing_only) ||
      Boolean(userData?.upgrade_required);
    if (!billingOnly) return;
    // Allow Billing hub + plans checkout while upgrade is required.
    if (!String(location.pathname).startsWith("/billing")) {
      navigate("/billing/plans?upgrade=1", { replace: true });
    }
  }, [location.pathname, navigate, userData?.billing_only, userData?.upgrade_required]);

  useEffect(() => {
    if (!isLoggedIn || localStorage.getItem("ems_billing_only") === "1") {
      setTrialBanner(null);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const { fetchEmsBilling } = await import("../../Apis/EmsBilling");
        const data = await fetchEmsBilling();
        const sub = data?.subscription;
        if (cancelled || !sub) return;
        if (sub.is_subscription_active && sub.days_left != null) {
          // Show reminder only in the last month of the subscription.
          if (Number(sub.days_left) <= 30) {
            setTrialBanner({
              daysLeft: sub.days_left,
              planName: sub.plan_name || "Trial",
              endDate: sub.end_date,
            });
          } else {
            setTrialBanner(null);
          }
        } else if (sub.upgrade_required) {
          setTrialBanner({ expired: true, endDate: sub.end_date });
        } else {
          setTrialBanner(null);
        }
      } catch {
        if (!cancelled) setTrialBanner(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isLoggedIn, location.pathname]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "/") {
        setOpenTCode(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const [isAllowed, setisAllowed] = useState(true);

  useEffect(() => {
    const currentPath = location.pathname;
    localStorage.setItem("lastVisitedRoute", currentPath);

    if (currentPath && Permission?.length > 0) {
      // alert("gugug")

      const basePath = currentPath.includes("/edit")
        ? `${currentPath.split("/edit")[0]}/edit`
        : currentPath.startsWith("/followup-structures/view")
          ? "/followup-structures/view"
          : currentPath;

      const matchedRoute = routes.find((item) => item.name === basePath);
      console.log("match", matchedRoute);
      const hasRoutePermission = (action) => hasPermissionAction(Permission, action);

      const listPath = trainerListPath(currentPath);
      const currentWorkspace = resolveActiveWorkspace(
        useAuthStore.getState().userData,
        Permission
      );
      const permittedWorkspaces = allowedWorkspaces(
        useAuthStore.getState().userData,
        Permission
      );
      const pathWorkspace = workspaceForPath(currentPath);
      if (
        pathWorkspace &&
        pathWorkspace !== currentWorkspace &&
        permittedWorkspaces.includes(pathWorkspace)
      ) {
        setStoredWorkspace(pathWorkspace);
        setWorkspaceTick((value) => value + 1);
      }

      const trainerMayOpen =
        currentWorkspace === WORKSPACES.TRAINER &&
        (TRAINER_PORTAL_ROUTES.includes(listPath) || listPath === "/dashboard");
      const studentMayOpen =
        currentWorkspace === WORKSPACES.STUDENT &&
        currentPath.startsWith("/student");

      if (
        currentWorkspace === WORKSPACES.STUDENT &&
        !currentPath.startsWith("/student") &&
        currentPath !== "/help" &&
        currentPath !== "/settings/change-password" &&
        !currentPath.startsWith("/organization/")
      ) {
        setisAllowed(false);
      } else if (
        currentWorkspace === WORKSPACES.TRAINER &&
        !trainerMayOpen &&
        currentPath !== "/help" &&
        currentPath !== "/settings/change-password" &&
        !currentPath.startsWith("/organization/")
      ) {
        if (permittedWorkspaces.includes(WORKSPACES.STAFF) && pathWorkspace === WORKSPACES.STAFF) {
          setisAllowed(true);
        } else {
          setisAllowed(false);
        }
      } else if (!matchedRoute) {
        setisAllowed(true);
      } else if (
        studentMayOpen ||
        trainerMayOpen ||
        (matchedRoute.action && hasRoutePermission(matchedRoute.action))
      ) {
        setisAllowed(true);
      } else {
        setisAllowed(false);
      }
    }
  }, [location, Permission]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      clearSessionAndGoToLogin();
      return;
    }

    const storeUser = useAuthStore.getState().userData;
    const hasRoleLabel = Boolean(
      String(storeUser?.role_name || storeUser?.role?.user_role_name || "").trim()
    );
    const alreadyHydrated =
      storeUser &&
      (storeUser.organizationuser?.organization_user_id ||
        (Array.isArray(storeUser.metadata) && storeUser.metadata.length > 0));

    if (alreadyHydrated && hasRoleLabel) {
      return;
    }

    axios
      .get(`${MAIN_URL}/api/auth/token-login`, {
        headers: getApiHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
      .then((response) => {
        let { user } = response.data;

        const allOrgs = Array.isArray(user?.organization) ? user.organization : [];

        user = applyPreferredOrganizationToUserPayload(user);

        setAccess(resolveUserRoleLabel(user));

        const activeOrgId =
          user?.user_active_organization?.organization_id ||
          user?.user_active_organization?.user_current_active_organization_id ||
          user?.activeOrganization?.user_current_active_organization_id ||
          user?.activeOrganization?.organization_id;

        const dd = allOrgs.find(
          (item) => Number(item.organization_id) === Number(activeOrgId)
        );

        const mergedOrgUser =
          user?.organizationuser ||
          user?.metadata?.find(
            (item) => Number(item?.organization_id) === Number(activeOrgId)
          );

        const mm = {
          ...user,
          organizations: allOrgs,
          organization: dd ?? allOrgs[0] ?? null,
          organizationuser: mergedOrgUser ?? user.organizationuser,
        };
        login(mm);
      })
      .catch(() => {
        clearSessionAndGoToLogin();
      });
  }, [clearSessionAndGoToLogin, login, setAccess]);

  useEffect(() => {
    const currentPath = location.pathname;
    if (
      currentPath === "/organization/employee/employee-details/add" ||
      currentPath === "/organization/employee/employee-details"
    ) {
      resetData();
    }
  }, [location.pathname]);

  useEffect(() => {
    const currentPath = location.pathname;
    if (
      currentPath === "/organization/intern/intern-details/add" ||
      currentPath === "/organization/intern/intern-details"
    ) {
      resetData();
    }
  }, [location.pathname]);

  // useEffect(() => {
  //   const checkPermission = async () => {
  //     setLoadPermission(true);

  //     try {
  //       const res = await axios.get(
  //         `${MAIN_URL}/api/user/${userData?.metadata?.[0]?.organization_user_id}/has-access`
  //       );

  //       const allowed = res?.data?.allowed_actions || [];
  //       setPermission(allowed);

  //       // Redirect immediately if no permission
  //       if (allowed.length === 0) {
  //         return navigate("/not-authorised");
  //       }
  //     } catch (error) {
  //       console.error("Permission check error:", error);
  //     } finally {
  //       setLoadPermission(false);
  //     }
  //   };

  //   if (userData?.metadata?.[0]?.organization_user_id) {
  //     checkPermission();
  //   }
  // }, [userData?.metadata?.[0]?.organization_user_id]);


  useEffect(() => {
    const token = localStorage.getItem("token");
    const storeUser = useAuthStore.getState().userData;

    if (!normalizedOrgUserId) {
      lastCompletedPermissionOrgUserId = null;
      setPermission([]);
      if (!token) {
        setLoadPermission(false);
      } else if (!storeUser) {
        setLoadPermission(true);
      } else {
        setLoadPermission(false);
      }
      return;
    }

    if (permissionsAlreadyLoaded(normalizedOrgUserId)) {
      setLoadPermission(false);
      return;
    }

    const ac = new AbortController();
    let cancelled = false;

    const run = async () => {
      setLoadPermission(true);
      try {
        const res = await axios.get(
          `${MAIN_URL}/api/user/${normalizedOrgUserId}/check-permission-access`,
          {
            signal: ac.signal,
            headers: getApiHeaders(),
          }
        );
        if (cancelled) return;

        const userData = useAuthStore.getState().userData;
        const allowed = withTrainerPortalPermissions(
          await mergeGrantedMenuPermissions(res?.data?.allowed_actions || [], userData),
          userData
        );
        setPermission(allowed);
        if (userData && (res?.data?.roles || res?.data?.workspaces)) {
          login({
            ...userData,
            roles: res.data.roles || userData.roles,
            workspaces: res.data.workspaces || userData.workspaces,
            role_name: res.data.role_name || userData.role_name,
          });
        }

        if (allowed.length === 0) {
          lastCompletedPermissionOrgUserId = null;
          navigate("/not-authorised", { replace: true });
          return;
        }
        lastCompletedPermissionOrgUserId = normalizedOrgUserId;
      } catch (error) {
        if (cancelled || error?.code === "ERR_CANCELED") return;
        console.error("Permission check error:", error);
        if (error.response?.status === 404) {
          navigate("/not-authorised", { replace: true });
        }
      } finally {
        if (!cancelled) {
          setLoadPermission(false);
        }
      }
    };

    run();

    return () => {
      cancelled = true;
      ac.abort();
    };
  }, [normalizedOrgUserId, navigate, setPermission]);

  useEffect(() => {
    if (!isTrainerPortalUser(userData, Permission)) return;
    const next = withTrainerPortalPermissions(Permission, userData);
    if (next.length !== (Permission || []).length) {
      setPermission(next);
    }
  }, [userData, Permission, setPermission]);

  

  // 🚫 Block component rendering until permission check finishes
  if (loadPermission) {
    return (
      <div className="ems-perm-loading">
        <div className="ems-perm-card">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none"
            style={{ animation: "spin 0.9s linear infinite" }}>
            <circle cx="18" cy="18" r="15" stroke="var(--ems-border-strong)"
              strokeWidth="3" fill="none" />
            <path d="M18 3 A15 15 0 0 1 33 18" stroke="var(--ems-primary)"
              strokeWidth="3" strokeLinecap="round" fill="none" />
          </svg>
          <p className="ems-perm-title">Checking Permissions…</p>
          <p className="ems-perm-sub">Setting up your workspace</p>
        </div>
      </div>
    );
  }

  // 🔐 Route-based Access Control

  const currentPath = location.pathname;
  //console.log("current path is sikjs", currentPath);

  // Protect Employees Page from Admins
  if (access === "Admin" && currentPath === "/sidebar-option-page-1") {
    return <Navigate to="/" replace />;
  }

  // Protect Admin-only page from Users
  if (!isAllowed) {
    return <NotAllowed />;
  }


  console.log("axcess", access);
  console.log("userdata", userData);

  const canNavigateToOrganizationPage = canViewOrganizationPage(Permission);

  const handleOrganizationNameClick = () => {
    if (canNavigateToOrganizationPage) {
      navigate("/organization/switcher");
    }
  };

  const handleSidebarExpand = () => {
    if (isMobile) {
      setMobileOpen(true);
      return;
    }
    setCollapsed(false);
    try {
      localStorage.setItem("ems-collapsed", "0");
    } catch {
      // Ignore storage failures.
    }
  };

  const renderSidebarContent = () => (
    <SideBar
      Permission={Permission}
      collapsed={collapsed && !isMobile}
      onRequestExpand={handleSidebarExpand}
      workspace={activeWorkspace}
    />
  );

  const userProfileImageUrl = resolveUserProfileImageUrl(userData);

  const activeOrgId = activeOrganizationId;
  const activeOrgFromList = allClientOrgs.find(
    (o) => String(o.organization_id) === String(activeOrganization?.organization_id)
  );
  const activeOrgShort = String(
    activeOrganization?.organization_short_name ||
      activeOrgFromList?.organization_short_name ||
      ""
  ).trim();
  const activeOrgFullName = String(
    activeOrganization?.organization_name ||
      activeOrgFromList?.organization_name ||
      ""
  ).trim();
  const activeOrgLabel = isMobile
    ? activeOrgShort || activeOrgFullName || "EMS"
    : activeOrgFullName || activeOrgShort || "EMS";
  const studentOrganizations = (() => {
    if (!isStudentPortal) return [];
    const fromOrg = Array.isArray(userData?.organization)
      ? userData.organization
      : userData?.organization
        ? [userData.organization]
        : [];
    const fromOrgs = Array.isArray(userData?.organizations) ? userData.organizations : [];
    const seen = new Set();
    return [...fromOrg, ...fromOrgs].filter((org) => {
      const id = org?.organization_id;
      if (id == null) return false;
      const key = String(id);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  })();
  const studentHasSingleOrg = isStudentPortal && studentOrganizations.length <= 1;
  const studentPortalLoginuser = Array.isArray(userData?.loginuser)
    ? userData.loginuser[0]
    : userData?.loginuser;
  const studentDisplayId = String(
    studentPortalLoginuser?.student_id ||
      userData?.student_id ||
      ""
  ).trim();
  const studentCountryName = String(
    studentPortalLoginuser?.country_name ||
      studentPortalLoginuser?.country?.country_name ||
      studentPortalLoginuser?.country?.name ||
      userData?.country_name ||
      ""
  ).trim();
  const filteredOrgs = allClientOrgs.filter((o) =>
    !orgQuery || (o.organization_name || "").toLowerCase().includes(orgQuery.toLowerCase())
  );

  const canInstituteSettings = hasPermissionAction(Permission, "INSTITUTE_SETTINGS_ALL");
  const canBilling = hasPermissionAction(Permission, "BILLING_ALL");
  const canStaffNotifications = hasPermissionAction(Permission, "NOTIFICATIONS_ALL");
  const canNotifications = canStaffNotifications || isStudentPortal;
  const studentNotifCount = studentNotifications.length;
  const headerUnreadCount = isStudentPortal ? studentNotifCount : unreadCount;
  const headerNotifsLoading = isStudentPortal ? studentNotifsLoading : notificationsLoading;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="ems-shell">
        {activeMenu && (
          <div
            className="ems-tb-pop-backdrop"
            aria-hidden="true"
            onPointerDown={(e) => {
              e.preventDefault();
              closeMenu();
            }}
          />
        )}
        {trialBanner && canBilling && (
          <div
            style={{
              background: trialBanner.expired ? "#fef3c7" : "#ecfdf5",
              borderBottom: "1px solid " + (trialBanner.expired ? "#f59e0b" : "#99f6e4"),
              padding: "10px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 12,
              fontSize: 14,
              lineHeight: 1.35,
              flexWrap: "wrap",
              color: "#0f172a",
              zIndex: 20,
            }}
          >
            <span>
              {trialBanner.expired ? (
                `${
                  trialBanner.planName?.toLowerCase().includes("trial")
                    ? "Trial plan expired"
                    : `${trialBanner.planName} expired`
                }: Ended on ${
                  trialBanner.endDate ? formatEndsOnLong(trialBanner.endDate) : ""
                }. Upgrade now!`
              ) : (
                `${
                  trialBanner.planName?.toLowerCase().includes("trial")
                    ? "Trial plan active"
                    : `${trialBanner.planName} active`
                }: ${trialBanner.daysLeft} day${
                  trialBanner.daysLeft === 1 ? "" : "s"
                } left${
                  trialBanner.endDate
                    ? ` (Ends on ${formatEndsOnLong(trialBanner.endDate)})`
                    : ""
                }. Upgrade now!`
              )}
            </span>
            <button
              type="button"
              onClick={() => navigate("/billing/plans")}
              style={{
                border: "none",
                background: "#0f766e",
                color: "#fff",
                borderRadius: 8,
                padding: "6px 12px",
                cursor: "pointer",
                fontWeight: 600,
                lineHeight: 1.1,
              }}
            >
              Upgrade Plan
            </button>
          </div>
        )}
        {/* ── Topbar ── */}
        <header className="ems-topbar">
          <div className="ems-topbar-lead">
            <button className="ems-icon-btn" onClick={handleDrawerToggle} aria-label="Toggle sidebar">
              <MenuIcon style={{ fontSize: 21 }} />
            </button>
            <div className="ems-brand" onClick={() => navigate(getDefaultHomePath(userData))}>
              <InssureLogo className="ems-brand-mark" />
            </div>
          </div>

          {/* Org switcher — students with one org see the name only */}
          <div className="ems-tb-anchor ems-org-switch">
            {studentHasSingleOrg ? (
              <div className="ems-company-chip is-static">
                <span className="ems-company-name" title={activeOrgFullName || activeOrgLabel}>
                  {activeOrgLabel}
                </span>
              </div>
            ) : (
            <button
              className={`ems-company-chip${activeMenu === "org" ? " on" : ""}`}
              onClick={() => { toggleMenu("org"); setOrgQuery(""); }}
            >
              <span className="ems-company-name" title={activeOrgFullName || activeOrgLabel}>
                {activeOrgLabel}
              </span>
              <ChevronsUpDown size={16} />
            </button>
            )}
            {!studentHasSingleOrg && activeMenu === "org" && (
              <div className="ems-tb-pop ems-tb-pop-org">
                <div className="ems-tb-pop-head">
                  <span className="ems-tb-pop-title">Switch organization</span>
                </div>
                <div className="ems-tb-org-search">
                  <Search size={16} />
                  <input
                    placeholder="Search organizations…"
                    value={orgQuery}
                    onChange={(e) => setOrgQuery(e.target.value)}
                    autoFocus
                  />
                </div>
                <div className="ems-tb-org-list">
                  {orgListLoading ? (
                    <div className="ems-tb-empty">Loading…</div>
                  ) : filteredOrgs.length === 0 ? (
                    <div className="ems-tb-empty">No organizations found.</div>
                  ) : filteredOrgs.map((o) => {
                    const isActive = String(o.organization_id) === String(activeOrgId);
                    const isSwitching = orgSwitching === o.organization_id;
                    const name = o.organization_name || "Organization";
                    const short = name.split(" ").map((w) => w[0] || "").join("").toUpperCase().slice(0, 2);
                    return (
                      <button
                        key={o.organization_id}
                        className={`ems-tb-org${isActive ? " active" : ""}`}
                        disabled={!!orgSwitching}
                        onClick={() => { if (!isActive) switchOrg(o.organization_id); }}
                      >
                        <span className="ems-tb-org-logo">{short}</span>
                        <span className="ems-tb-org-meta">
                          <span className="ems-tb-org-name">{name}</span>
                          {o.organization_short_name && (
                            <span className="ems-tb-org-short">{o.organization_short_name}</span>
                          )}
                        </span>
                        {isSwitching
                          ? <span className="ems-tb-org-status">Switching…</span>
                          : isActive
                            ? <span className="ems-tb-org-status active"><span className="ems-tb-org-dot" />Active</span>
                            : <span className="ems-tb-org-status">Inactive</span>}
                      </button>
                    );
                  })}
                </div>
                <div className="ems-tb-pop-foot">
                  <button className="ems-tb-foot-btn" onClick={() => { closeMenu(); navigate("/organization/switcher"); }}>
                    Manage organizations
                  </button>
                </div>
              </div>
            )}
          </div>

          {userWorkspaces.length > 1 && (
            <div className="ems-tb-anchor ems-workspace-switch">
              <button
                className={`ems-company-chip${activeMenu === "workspace" ? " on" : ""}`}
                onClick={() => toggleMenu("workspace")}
                title="Switch workspace"
              >
                <span className="ems-company-name">
                  {WORKSPACE_LABELS[activeWorkspace] || "Workspace"}
                </span>
                <ChevronsUpDown size={16} />
              </button>
              {activeMenu === "workspace" && (
                <div className="ems-tb-pop ems-tb-pop-menu" style={{ minWidth: 220 }}>
                  <div className="ems-tb-pop-head">
                    <span className="ems-tb-pop-title">Switch workspace</span>
                  </div>
                  {userWorkspaces.map((item) => (
                    <button
                      key={item}
                      className={`ems-tb-item${item === activeWorkspace ? " on" : ""}`}
                      onClick={() => switchWorkspace(item)}
                    >
                      {WORKSPACE_LABELS[item] || item}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          <div className="ems-topbar-spacer" />

          <div className="ems-topbar-tools">
            {/* Dark mode toggle */}
            <button className="ems-icon-btn" onClick={() => setDarkMode(!darkMode)} title={darkMode ? "Light mode" : "Dark mode"}>
              {darkMode ? <Sun size={19} /> : <Moon size={19} />}
            </button>

            {/* Notifications */}
            {canNotifications && (
            <div className="ems-tb-anchor">
              <button
                className={`ems-icon-btn ems-notif-btn${activeMenu === "notif" ? " on" : ""}`}
                onClick={() => {
                  const opening = activeMenu !== "notif";
                  toggleMenu("notif");
                  if (opening && activeOrganizationId && !isStudentPortal) {
                    loadUnreadCount(activeOrganizationId);
                  }
                }}
                aria-label="Notifications"
              >
                <Bell size={19} />
                {headerUnreadCount > 0 && <span className="ems-notif-dot" />}
              </button>
              {activeMenu === "notif" && (
                <div className="ems-tb-pop ems-tb-pop-notif">
                  <div className="ems-tb-pop-head">
                    <span className="ems-tb-pop-title">
                      Notifications
                      {headerUnreadCount > 0 && (
                        <span className="ems-tb-badge" style={{ marginLeft: 8 }}>
                          {headerUnreadCount > 99 ? "99+" : headerUnreadCount}
                        </span>
                      )}
                    </span>
                    {!isStudentPortal && (
                    <button
                      className="ems-tb-link"
                      disabled={unreadCount === 0}
                      onClick={() => markAllRead(isAdminRole ? notifCategory : null)}
                    >
                      Mark all read
                    </button>
                    )}
                  </div>
                  {isAdminRole && !isStudentPortal && (
                    <div className="ems-notif-tabs">
                      {notifTabs.map((tab) => (
                        <button
                          key={tab.key}
                          type="button"
                          className={`ems-notif-tab${notifCategory === tab.key ? " active" : ""}`}
                          onClick={() => handleNotifTab(tab.key)}
                        >
                          {tab.label}
                        </button>
                      ))}
                    </div>
                  )}
                  {headerNotifsLoading ? (
                    <div className="ems-tb-empty">Loading…</div>
                  ) : isStudentPortal ? (
                    studentNotifications.length === 0 ? (
                    <div className="ems-tb-empty">No new notifications.</div>
                    ) : (
                    <div className="ems-tb-notif-list">
                      {studentNotifications.map((n, index) => (
                        <div
                          key={`${n.type || "note"}-${index}`}
                          className="ems-tb-notif unread"
                          role="button"
                          tabIndex={0}
                          onClick={() => handleStudentNotificationClick(n)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              handleStudentNotificationClick(n);
                            }
                          }}
                        >
                          <div className={`ems-tb-notif-ic is-${n.type || "class"}`}>
                            {studentNotificationIcon(n.type)}
                          </div>
                          <div className="ems-tb-notif-body">
                            <span className="ems-tb-notif-title">{n.title}</span>
                            {n.text && (
                              <span className="ems-tb-notif-text">{n.text}</span>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    )
                  ) : notificationItems.length === 0 ? (
                    <div className="ems-tb-empty">No notifications yet.</div>
                  ) : (
                    <div className="ems-tb-notif-list">
                      {notificationItems.map((n) => (
                        <div
                          key={n.notification_id}
                          className={`ems-tb-notif${!n.is_read ? " unread" : ""}`}
                          role="button"
                          tabIndex={0}
                          onClick={() => handleNotificationClick(n)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              handleNotificationClick(n);
                            }
                          }}
                        >
                          <div className="ems-tb-notif-ic">
                            <Bell size={16} />
                          </div>
                          <div className="ems-tb-notif-body">
                            <span className="ems-tb-notif-title">{n.title}</span>
                            {n.message && (
                              <span className="ems-tb-notif-text">{n.message}</span>
                            )}
                            <span className="ems-tb-notif-time">
                              {n.created_at ? timeAgoFormat(n.created_at) : ""}
                            </span>
                          </div>
                          <div className="ems-tb-notif-actions">
                            {!n.is_read && <span className="ems-tb-unread-dot" />}
                            <button
                              type="button"
                              className="ems-tb-notif-del"
                              title="Delete"
                              onClick={(e) => {
                                e.stopPropagation();
                                removeOne(n.notification_id);
                              }}
                            >
                              <Trash2 size={14} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {!isStudentPortal && (
                  <div className="ems-tb-pop-foot">
                    <button
                      className="ems-tb-foot-btn"
                      onClick={() => {
                        closeMenu();
                        setNotificationPrefsOpen(true);
                      }}
                    >
                      Notification preferences
                    </button>
                  </div>
                  )}
                </div>
              )}
            </div>
            )}

            {/* Help Center */}
            <button
              className="ems-icon-btn"
              title="Help Center"
              aria-label="Help Center"
              onClick={() => {
                closeMenu();
                navigate("/help");
              }}
            >
              <CircleHelp size={19} />
            </button>

            {/* Settings */}
            {canInstituteSettings && (
            <button
              className="ems-icon-btn"
              title="Institute settings"
              onClick={() => {
                closeMenu();
                setInstituteSettingsOpen(true);
              }}
            >
              <SettingsLucide size={19} />
            </button>
            )}

            {/* User menu */}
            <div className="ems-tb-anchor">
              <button
                className={`ems-user-chip${activeMenu === "user" ? " on" : ""}`}
                onClick={() => toggleMenu("user")}
                aria-label="User menu"
              >
                <span className="ems-user-name">{userData?.full_name || "User"}</span>
                <ListPersonAvatar imageUrl={userProfileImageUrl} size={34} />
              </button>
              {activeMenu === "user" && (
                <div className="ems-tb-pop ems-tb-pop-menu" style={{ minWidth: 260 }}>
                  <div className="ems-tb-user-head">
                    <ListPersonAvatar imageUrl={userProfileImageUrl} size={44} />
                    <div className="ems-tb-user-meta">
                      <span className="ems-tb-user-name">{userData?.full_name || "User"}</span>
                      <span className="ems-tb-user-mail">{userData?.email || ""}</span>
                      <span className="ems-tb-user-role">{roleLabel}</span>
                    </div>
                  </div>
                  <div className="ems-tb-divider" />
                  {isStudentPortal && (studentDisplayId || studentCountryName) ? (
                    <div className="ems-tb-user-facts">
                      {studentDisplayId ? (
                        <span>ID {studentDisplayId}</span>
                      ) : null}
                      {studentCountryName ? (
                        <span>{studentCountryName}</span>
                      ) : null}
                    </div>
                  ) : null}
                  {Permission && Permission.includes("USER_RESET_PASSWORD") && (
                    <button className="ems-tb-item" onClick={() => { closeMenu(); navigate("/settings/change-password"); }}>
                      <LockIcon style={{ fontSize: 17 }} />
                      Change Password
                    </button>
                  )}
                  {canBilling && (
                    <>
                      <button className="ems-tb-item" onClick={() => { closeMenu(); navigate("/billing"); }}>
                        <CreditCard size={17} />
                        Billing
                      </button>
                      <button className="ems-tb-item" onClick={() => { closeMenu(); navigate("/billing/plans"); }}>
                        <ArrowUpRight size={17} />
                        Upgrade Plan
                      </button>
                    </>
                  )}
                  <div className="ems-tb-divider" />
                  <button className={`ems-tb-item danger${isStudentPortal ? " ems-tb-item-align-meta" : ""}`} onClick={() => { closeMenu(); handleLogout(); }}>
                    <LogoutIcon style={{ fontSize: 17 }} />
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        <InstituteSettingsDialog
          open={instituteSettingsOpen}
          onClose={() => setInstituteSettingsOpen(false)}
          organizationId={activeOrganizationId}
        />

        <NotificationPreferencesDialog
          open={notificationPrefsOpen}
          onClose={() => setNotificationPrefsOpen(false)}
          organizationId={activeOrganizationId}
        />

        {/* ── Body ── */}
        <div className="ems-body">
          {isMobile && mobileOpen && (
            <div className="ems-sidebar-overlay" onClick={() => setMobileOpen(false)} />
          )}
          <aside className={["ems-sidebar", collapsed && !isMobile ? "ems-collapsed" : "", isMobile && mobileOpen ? "mobile-open" : ""].filter(Boolean).join(" ")}>
            {renderSidebarContent()}
          </aside>
          <main className="ems-content">
            <div className="ems-content-inner">{children}</div>
          </main>
        </div>
      </div>
    </ThemeProvider>
  );

}
